import { Circle as KonvaCircle } from "react-konva"
import { Transform } from "../../../../geometry/transformation"
import { hitStrokeCorrection } from "../../util/strokeCorrection";
import { useAppSelector } from "../../../../store/hooks";

const CircleBase = ({ shapeProps, onClick, interaction }: BaseShapeProps<CircleShape>) => {
    const center = new Transform(shapeProps.transformation).point2d({ x: shapeProps.x, y: shapeProps.y });
    const scale = useAppSelector(state => state.interface.viewport.scale)
    const { width, height, ...newProps } = {
        ...shapeProps,
        x: center.x,
        y: -center.y,
        id: shapeProps.id.toString(),
    }

    const correctedHitStrokeWidth = hitStrokeCorrection(shapeProps.hitStrokeWidth, shapeProps.strokeWidth, scale)
    return (
        <KonvaCircle
            dragBoundFunc={function (this, pos) {
                return this._lastPos || this.absolutePosition();
            }}
            onDragStart={interaction?.handleDragStart}
            onDragMove={interaction?.handleDragMove}
            onDragEnd={interaction?.handleDragEnd}
            onClick={onClick}
            {...newProps}
            hitStrokeWidth={correctedHitStrokeWidth}
        ></KonvaCircle>
    )
}
const createCircleBase = (shape: GeometricShape) => {
    return (
        <CircleBase shapeProps={shape as CircleShape} />
    )
}
export { createCircleBase }
export default CircleBase; 